import { BreakpointStart, Text } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: ${BreakpointStart.md}px) {
    gap: 1rem;
  }
`

export const Agreement = styled(Text).attrs({
  as: 'div',
  variant: 'content-03'
})`
  max-height: 40vh;
  overflow: auto;
  border: 2px solid #abbed1;
  border-radius: 4px;
  padding: 1rem;
  text-align: justify;
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #abbed1;

  > img {
    max-width: 100%;
  }
`

export const CanvasPlaceholderText = styled(Text).attrs({
  variant: 'bordertext-04'
})`
  position: absolute;
  z-index: 1;
  color: #abbed1;
  top: 10px;
  left: 12px;
`

export const CanvasContainer = styled.div`
  position: relative;
  display: flex;

  > button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background: none;
    border: 1px solid transparent;
    padding: 0;
    margin: 0;

    :hover {
      border: 1px solid #abbed1;
      border-radius: 4px;
    }
  }

  > canvas {
    width: 100%;
    min-height: 200px;
    max-height: 20vh;
    border: 2px solid #abbed1;
    border-radius: 4px;
  }

  &:hover ${CanvasPlaceholderText} {
    display: none;
  }
`

export const TextSignatureContainer = styled.div`
  border-radius: 4px;
  border: 2px solid #abbed1;
  padding: 10px 12px;
`

export const LabelArea = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: column;
  grid-auto-columns: 1.5rem;
  align-items: baseline;
  gap: 0.5rem;
  align-items: flex-end;
  margin-bottom: 0.25rem;
`
